import { render, staticRenderFns } from "./CardBlockModal.vue?vue&type=template&id=3e987d05&"
import script from "./CardBlockModal.vue?vue&type=script&lang=ts&"
export * from "./CardBlockModal.vue?vue&type=script&lang=ts&"
import style0 from "./CardBlockModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VCard,VForm})
